// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC3l0zGU6QHYWViPuPQoVjPkwZrTVYlBY8",
  authDomain: "finclify.firebaseapp.com",
  projectId: "finclify",
  storageBucket: "finclify.firebasestorage.app",
  messagingSenderId: "747018826218",
  appId: "1:747018826218:web:7cab182b9c798ecfabc293",
  measurementId: "G-HPZ75N9Z9B"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (only in browser environment)
// Defer initialization to improve page load performance
let analytics = null;
let analyticsInitialized = false;

// Function to initialize analytics asynchronously after page load
const initializeAnalytics = () => {
  if (typeof window === 'undefined' || analyticsInitialized) return;
  
  try {
    // Wait for page to be interactive before initializing analytics
    if (document.readyState === 'complete') {
      analytics = getAnalytics(app);
      analyticsInitialized = true;
    } else {
      // Defer until page is fully loaded
      window.addEventListener('load', () => {
        try {
          analytics = getAnalytics(app);
          analyticsInitialized = true;
        } catch (error) {
          // Analytics initialization failed
        }
      }, { once: true });
    }
  } catch (error) {
    // Analytics initialization failed
  }
};

// Initialize analytics after a short delay to prioritize page rendering
if (typeof window !== 'undefined') {
  // Use requestIdleCallback if available, otherwise setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initializeAnalytics, { timeout: 2000 });
  } else {
    setTimeout(initializeAnalytics, 1000);
  }
}

// Helper function to ensure analytics is ready
const ensureAnalytics = () => {
  if (typeof window === 'undefined') return null;
  if (!analytics && !analyticsInitialized) {
    initializeAnalytics();
  }
  return analytics;
};

// Function to log page views
export const logPageView = (path) => {
  if (typeof window === 'undefined') return;
  
  const analyticsInstance = ensureAnalytics();
  if (!analyticsInstance) {
    return;
  }
  
  try {
    logEvent(analyticsInstance, 'page_view', {
      page_path: path,
      page_title: document.title || 'Finance Tools',
      page_location: window.location.href
    });
  } catch (error) {
  }
};

// Function to log custom events
export const logEventCustom = (eventName, eventParams = {}) => {
  if (typeof window === 'undefined') return;
  
  const analyticsInstance = ensureAnalytics();
  if (!analyticsInstance) {
    console.warn('⚠️ Analytics not available for event:', eventName);
    return;
  }
  
  try {
    logEvent(analyticsInstance, eventName, eventParams);
  } catch (error) {
  }
};

export { app, analytics };

